<template>
    <div>
        <div ref="printPdf">
            <!-- Header -->
            <div style="margin-bottom: 20px;">
                <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                    <div>
                        <p style="font-size: 18px; font-weight: bold; margin: 0 0 4px 0; color: #333;">
                            BAY ATLANTIC UNIVERSITY / MENTORA COLLEGE
                        </p>
                        <p style="font-size: 16px; font-weight: bold; margin: 0 0 4px 0; color: #333;">
                            TEFL CERTIFICATE PROGRAM ENROLLMENT AGREEMENT
                        </p>
                        <p style="font-size: 13px; margin: 0; color: #555;">
                            <strong>REVISION DATE:</strong> 06/01/2026
                        </p>
                    </div>
                    <div style="flex-shrink: 0;">
                        <img
                            src="../../../assets/img/BAU_Logo.png"
                            :alt="$t('agreement_form_title')"
                            style="height: 60px; width: auto;"
                            ref="logoImage"
                        />
                    </div>
                </div>
                <hr style="margin: 16px 0;">
                <div class="mb-3 mt-3">
                    <strong style="font-size: 13px;">
                        BY CLICKING THE BOX AT THE END OF THIS DOCUMENT INDICATING YOUR ACCEPTANCE (THE "ACCEPTANCE") OF THIS ENROLLMENT CONTRACT (THIS "AGREEMENT"), YOU AGREE YOU HAVE READ AND ARE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE WITH THIS AGREEMENT, YOU MUST NOT ACCEPT THIS AGREEMENT AND MUST NOT CONTINUE WITH COURSE REGISTRATION. DOING SO MEANS YOU START AN OFFICIAL WITHDRAWAL PROCESS. IF YOU ACCEPT THIS AGREEMENT, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD, AND ARE BOUND BY, THE TERMS AND CONDITIONS STATED HEREIN.
                    </strong>
                </div>
                <div class="mb-4">
                    <p>
                        This Agreement is by and between you and BAY ATLANTIC UNIVERSITY (the "BAU") /
                        Mentora College and is effective as of the date of Acceptance (the "Effective Date"). It
                        governs your academic and financial rights and responsibilities.
                    </p>
                </div>
            </div>

            <!-- SECTION A -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">SECTION A: VERIFICATION OF PERSONAL INFORMATION</h4>
            <p style="font-size: 13px; margin-bottom: 12px;">
                The following information is pulled from the application form you submitted. If you need
                to update the information, you can click on the Edit Button.
            </p>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 12px; font-size: 13px;">
                <tbody>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Full Name :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.name }} {{ registrationForm.middle_name }} {{ registrationForm.surname }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Date of Birth :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.birthdate ? toLocaleDate(registrationForm.birthdate) : '' }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">U.S. Mailing Address :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.apartment ? registrationForm.apartment + ' / ' : '' }}{{ registrationForm.contact_address }} / {{ registrationForm.contact_city_name }} / {{ registrationForm.contact_state_name }} {{ registrationForm.contact_zip_code }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Your Home Address (International Students) :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.address }} / {{ registrationForm.address_country_name }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Your Personal Email :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.personal_email }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Your U.S. Mobile Phone :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.mobile_tel ? (registrationForm.mobile_tel_country_code ?? '') + registrationForm.mobile_tel : '' }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Emergency Contact Name &amp; Relationship :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.emergency_person_name }} / {{ registrationForm.emergency_person_relation }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Emergency Contact Telephone Number :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.emergency_person_phone ? (registrationForm.emergency_person_phone_country_code ?? '') + registrationForm.emergency_person_phone : '' }}
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Current Legal Presence Type :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.legal_presence_type }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style="margin-bottom: 16px; font-size: 13px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                I confirm that the information given in this section is true, complete, and accurate.
                            </td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;">
                                <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- SECTION B -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">SECTION B: PROGRAM INFORMATION</h4>
            <p style="font-size: 13px; margin-bottom: 12px;">The following information reflects your specific certificate cohort placement.</p>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 12px; font-size: 13px;">
                <tbody>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Program of Study :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">Teaching English as a Foreign Language (TEFL) Certificate</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Program Structure :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">Non-credit professional certification journey (120 Clock Hours)</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Instructional Modality :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">{{ registrationForm.registration_type_text }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Program Duration / Timeline :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">
                            {{ registrationForm.active_module_start_date }} – {{ registrationForm.active_module_end_date }}.
                            The maximum time allowed to complete the full 120-hour course is 8 weeks from the closing date of your enrolled cohort.
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Total Credits Required for Graduation :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">0 Credits (This is a non-credit program; completion is verified via assessment, observations, reflections, and Practicum).</td>
                    </tr>
                </tbody>
            </table>
            <div style="margin-bottom: 16px; font-size: 13px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">I read and confirm that I understand the information in Section B.</td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;"><input type="checkbox" checked disabled style="width: 16px; height: 16px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- SECTION C -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">SECTION C: FEES AND CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE</h4>
            <p style="font-size: 13px; margin-bottom: 12px;">The following fees and charges reflect the financial structure of the TEFL certificate program cohort.</p>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 12px; font-size: 13px;">
                <tbody>
                    <tr v-for="(item, j) in feesData" :key="j" style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">{{ item.key }} :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;"><span v-html="item.value"></span></td>
                    </tr>
                </tbody>
            </table>
            <div style="margin-bottom: 16px; font-size: 13px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">I read and confirm that I understand the information in Section C.</td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;"><input type="checkbox" checked disabled style="width: 16px; height: 16px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- SECTION D -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">SECTION D: SCHOLARSHIPS / TUITION ASSISTANCE / AWARDS</h4>
            <p style="font-size: 13px; margin-bottom: 12px;">Scholarships and tuition assistance are available using university funds allocated for students who need additional financial aid.</p>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 12px; font-size: 13px;">
                <tbody>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Type of Awarded Program Assistance :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">{{ studentData.scholarship_name || '–' }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="font-weight: bold; width: 220px; padding: 6px 10px 6px 0; color: #555; vertical-align: top;">Total Assistance Amount Awarded :</td>
                        <td style="padding: 6px 0; color: #333; vertical-align: top;">${{ studentData.total_discount_amount || '–' }}</td>
                    </tr>
                </tbody>
            </table>
            <ul style="font-size: 13px;">
                <li><strong>Award Performance Maintenance Criteria:</strong>
                    <ul>
                        <li>Continuously participate in courses to meet programmatic completion milestones.</li>
                        <li>Maintain a minimum cumulative course grade of 80% on each component of the course.</li>
                        <li>Avoid any disciplinary action, professional misconduct, or academic honesty violations.</li>
                    </ul>
                </li>
                <li><strong>Repayment Obligation:</strong> If a student who was awarded any scholarship or tuition assistance withdraws or is dismissed from the TEFL program for any reason, they are required to pay the award amount back for all course components completed since the award was issued.</li>
            </ul>
            <div style="margin-bottom: 16px; font-size: 13px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">I read and confirm that I understand the information in Section D.</td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;"><input type="checkbox" checked disabled style="width: 16px; height: 16px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- SECTION E -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">SECTION E: STUDENT'S RIGHT TO CANCEL (WITHDRAWAL) AND REFUND POLICY</h4>
            <p style="font-size: 13px; margin-bottom: 12px;">If a student elects to cancel their registration or withdraw from the TEFL certificate program, the following strict timeline replaces standard semester schedules:</p>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 12px; font-size: 13px; border: 1px solid #ccc;">
                <thead>
                    <tr style="background: #f5f5f5;">
                        <th style="padding: 8px; border: 1px solid #ccc; text-align: left;">Written Request Submission Timeline</th>
                        <th style="padding: 8px; border: 1px solid #ccc; text-align: left;">Refund Percentage Allowed</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ccc; font-weight: bold; vertical-align: top;">At least seven (7) business days before the course start date</td>
                        <td style="padding: 8px; border: 1px solid #ccc; vertical-align: top;">If a student withdraws from a class before classes begin, the student will be liable for an Administrative Cancellation Fee of $150.00 and the balance of the tuition will be refunded.</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ccc; font-weight: bold; vertical-align: top;">Within the 1st week of the program (prior to Friday deadline)</td>
                        <td style="padding: 8px; border: 1px solid #ccc; vertical-align: top;">If a student withdraws during the first week of scheduled classes, the student will be charged an Administrative Cancellation Fee of $150 and 25% of the tuition.</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ccc; font-weight: bold; vertical-align: top;">After the conclusion of the 1st week of the program (after 5:00pm EST)</td>
                        <td style="padding: 8px; border: 1px solid #ccc; vertical-align: top;">No Refund. All tuition and fees are non-refundable after the first week of scheduled classes (last business day of the first week by 5:00 pm EST).</td>
                    </tr>
                </tbody>
            </table>
            <ul style="font-size: 13px;">
                <li><strong>Exclusions:</strong> Refunds exclude all registration fees, deposits, and mandatory administrative charges, which remain strictly non-refundable.</li>
                <li><strong>Refund Request Deadline:</strong> All refund requests must be submitted within three (3) business days following your official programmatic withdrawal date.</li>
                <li><strong>Official Process:</strong> Requests for withdrawal must be initiated formally on MyBAU or submitted directly in writing to the Mentora College Administrative team.</li>
            </ul>
            <div style="margin-bottom: 16px; font-size: 13px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">I read and confirm that I understand the information in Section E.</td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;"><input type="checkbox" checked disabled style="width: 16px; height: 16px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- SECTION F -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">SECTION F: ACADEMIC STANDARDS AND FINANCIAL GOOD STANDING</h4>
            <ul style="font-size: 13px;">
                <li><strong>Academic Progression &amp; Sequential Requirements:</strong> The TEFL program curriculum is strictly sequential. You must successfully pass all theoretical input sessions (quizzes, observations, and micro-teaching) with an 80% baseline before you are permitted to advance to the final Teaching Practicum.</li>
                <li><strong>Course Repetition Limit:</strong> If an academic component (quiz, observation, or micro-teaching assignment) is failed, you are permitted to repeat it exactly once. Failure to reach the 80% threshold on the second attempt results in automatic dismissal from the program.</li>
                <li><strong>Attendance Policy:</strong> A minimum of 90% attendance is mandatory for all modalities (in-person, online or hybrid). Active presence during the entirety of synchronous online meetings is required to count toward compliance. Falling below an 90% threshold can result in mandatory make-up hours or immediate programmatic dismissal.</li>
                <li><strong>Account Delinquency &amp; Service Suspension:</strong> Services, including access to the LMS, course components, grading portals, and final certification release, will be immediately suspended for students with an outstanding financial balance due. Course marks will not be certified until financial balances are clear.</li>
                <li><strong>Delinquent Penalties:</strong> Unpaid balances may be sent to collection procedures with the DC Office of Tax and Revenue and the Office of the Attorney General, incurring an additional collection penalty up to thirty percent (30%) of the past due balance, administrative costs, and reasonable attorney fees.</li>
                <li><strong>Late Fees &amp; Returned Checks:</strong> Failure to make payment deadlines results in a $80 late fee. A $35 fee is assessed for unpaid checks returned by banks.</li>
                <li><strong>Exceptional Mitigation:</strong> In documented instances of prolonged illness, accidents, or death in the immediate family, the administration will work toward an equitable and fair programmatic accommodation.</li>
            </ul>
            <div style="margin-bottom: 16px; font-size: 13px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">I read and confirm that I understand the information in Section F.</td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;"><input type="checkbox" checked disabled style="width: 16px; height: 16px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- SECTION G -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">SECTION G: OTHER AGREEMENTS AND POLICIES</h4>
            <ul style="font-size: 13px;">
                <li><strong>Program Handbook &amp; Catalog Compliance:</strong> Students are expected to read, understand, and comply with all specific provisions outlined in the <em>TEFL Program Handbook</em> and the university's overarching <em>Academic Catalog</em>.</li>
                <li><strong>Professional Conduct:</strong> Disruptive behavior, unprofessionalism during peer observations, or failure to follow the code of conduct during live teaching practicums serves as grounds for immediate termination from the program without a refund.</li>
                <li><strong>Academic Honesty:</strong> Plagiarism, cheating, misrepresentation of work, or the unauthorized use of AI tools in curriculum and lesson planning is strictly prohibited and subject to programmatic expulsion.</li>
                <li><strong>Official Communication:</strong> All official programmatic communication is conducted through the institutional LMS and university email. Students are required to check these channels daily.</li>
                <li><strong>Certificate Award:</strong> The <em>Mentora College TEFL Certificate</em> will be officially conferred within 60 days of successfully completing all academic modules, the required practical teaching hours, and satisfying all financial balances due to BAU.</li>
                <li><strong>Implied Consent for Media:</strong> You agree that BAU or its representatives may photograph, video, or record you during required workshops and teaching demonstrations for program documentation or marketing. If you do not wish to participate, you must advise the administration in writing prior to or at the time of recording.</li>
                <li><strong>Grievance Resolution:</strong> Any program complaints that cannot be resolved directly with the Academic Director or Administrative Assistant through written grievance procedures can be formally filed with the Higher Education Licensure Commission (HELC) at 1050 First Street NE, Washington, DC 20002.</li>
                <li><strong>Governing Jurisdiction:</strong> This agreement is governed by the laws and statutes of the District of Columbia. Any litigation stemming from this contract must reside exclusively within the courts of Washington, D.C.</li>
            </ul>
            <div style="margin-bottom: 16px; font-size: 13px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">I read and confirm that I understand the information in Section G.</td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;"><input type="checkbox" checked disabled style="width: 16px; height: 16px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- FINAL ACKNOWLEDGEMENT -->
            <hr style="margin: 16px 0;">
            <h4 style="font-size: 15px; font-weight: bold; margin: 16px 0 8px 0; color: #333;">FINAL ACKNOWLEDGEMENT &amp; ELECTRONIC ACCEPTANCE</h4>
            <div style="font-size: 13px; margin-bottom: 12px;">
                <p><strong>FINAL ACKNOWLEDGEMENT</strong></p>
                <p>I acknowledge and agree that the terms and conditions of this Enrollment Agreement and the Student Handbook are not subject to amendment or modification by spoken agreement. I further acknowledge and agree that no spoken statements have been made to me that are contrary to what is contained in this Enrollment Agreement or the Student Handbook. My signature below certifies that I have read, understand, and agree to comply with all terms, conditions, policies, rules, and procedures contained in this Enrollment Agreement and the Student Handbook, including any updates or revisions made in accordance with institutional policy. I understand that the Student Handbook is included in this Enrollment Agreement and forms an important part of this contract. This Enrollment Agreement is legally binding when signed by me and accepted by Bay Atlantic University, Mentora College TEFL Certificate Program.</p>
            </div>
            <div style="font-size: 13px; margin-bottom: 16px;">
                <p><strong>CONTRACT ACCEPTANCE</strong></p>
                <p>I, the undersigned, have read and understood this agreement and agree that it, together with the Student Handbook, supersedes all prior or existing verbal or written agreements. This agreement may not be modified/changed except by written agreement signed by both the student and the School Official.</p>
                <p>I also understand that if I default on this agreement, I will be responsible for paying any collection fees or attorney fees assessed by Bay Atlantic University (BAU). By clicking the box below, I hereby affix my electronic signature, indicating my intent to be legally bound by the terms of this Enrollment Agreement and the Student Handbook. My signature below signifies that I have read, understood, and acknowledged all aspects of this agreement, and I have recognized my legal responsibilities under this contract.</p>
            </div>
            <div style="font-size: 13px; margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 6px 0; color: #333; vertical-align: top; width: calc(100% - 30px);"><strong>I ACCEPT THE TERMS OF THIS AGREEMENT</strong></td>
                            <td style="padding: 6px 0; vertical-align: top; width: 30px; text-align: right;"><input type="checkbox" checked disabled style="width: 16px; height: 16px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="font-size: 13px; margin-top: 12px;">
                <p><strong>Student Full Name:</strong> {{ studentData.name + ' ' + studentData.surname }}</p>
                <p><strong>Date:</strong> {{ currentDate }}</p>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-4 d-flex justify-content-end no-print">
            <b-button variant="primary" @click="generatePdf" :disabled="isLoading" class="mr-2">
                <span v-if="isLoading">{{ $t('loading') }}...</span>
                <span v-else>{{ $t('send') }}</span>
            </b-button>
        </div>
    </div>
</template>
<script>
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
    data() {
        return {
            isLoading: false,
            registrationForm: {},
            feesData: [],
        }
    },
    computed: {
        ...mapGetters({
            studentData: "enrollmentAgreementForm/formData"
        }),
        currentDate() {
            return moment().format("MMMM Do YYYY")
        }
    },
    created() {
        this.getData();
    },
    methods: {
        toLocaleDate(date) {
            if (!date) return '';
            return moment(date).format('MM/DD/YYYY');
        },
        async getData() {
            const data = this.studentData;
            this.registrationForm = { ...data };
            this.feesData = [
                {
                    key: 'Tuition Deposit',
                    value: `$${data?.tuition_deposit ?? 'xxx'} – Non-Refundable (credited toward total tuition).`,
                },
                {
                    key: 'Total TEFL Course Tuition',
                    value: `$${data?.tuition_fee ? parseFloat(data.tuition_fee) : 'xxx'} (Flat rate course cost covers all 120 instructional hours, LMS digital teaching tool access, integrated career seminars and completion certificate).`,
                },
                {
                    key: 'Mandatory Program Fees',
                    value: 'Student Identification Card $22. (For in-person modality only)',
                },
                {
                    key: 'Other Fees May Apply',
                    value: 'Institutional documentation requests (transcripts, enrollment verifications and academic records) may require payment of the relevant fee(s). Information about university fees can be found on Bay Atlantic University\'s website.',
                },
            ];
        },
        async generatePdf() {
            this.isLoading = true;
            await this.sendToBackend();
            this.isLoading = false;
        },
        async sendToBackend() {
            const config = {
                contact_address: this.studentData.contact_address,
                contact_state_id: this.studentData.contact_state_id,
                contact_city_id: this.studentData.contact_city_id,
                contact_zip_code: this.studentData.contact_zip_code,
                apartment: this.studentData.apartment,
                address_country_id: this.studentData.address_country_id,
                address: this.studentData.address,
                verification_code: this.studentData.verification_code,
                personal_email: this.studentData.personal_email,
                mobile_tel: this.studentData.mobile_tel,
                mobile_tel_country_code: this.studentData.mobile_tel_country_code,
                home_tel: this.studentData.home_tel,
                home_tel_country_code: this.studentData.home_tel_country_code,
                emergency_person_phone_country_code: this.studentData.emergency_person_phone_country_code,
                emergency_person_relation: this.studentData.emergency_person_relation,
                emergency_person_name: this.studentData.emergency_person_name,
                emergency_person_phone: this.studentData.emergency_person_phone,
                birthdate: this.studentData.birthdate,
            };
            try {
                const response = await EnrollmentAgreementForm.sendForm(config);
                if (response.data.success === true) {
                    this.$toast.success(this.$t('form_submission_successful'));
                    this.$emit('sendSuccessForm', true);
                    this.clearForm();
                    this.$router.push('/dashboard');
                } else {
                    this.$toast.error(this.$t('api.' + response.data.message));
                    this.clearForm();
                }
            } catch (error) {
                if (error?.data?.message === "SMS_CODE_ERROR") {
                    this.$toast.error(this.$t('api.' + error.data.message));
                    this.$emit('errorSmsCode', true);
                } else {
                    this.$toast.error(this.$t('api.' + error?.data?.message));
                }
            }
        },
        async clearForm() {
            await this.$store.dispatch('enrollmentAgreementForm/deleteFormData');
        },
    },
};
</script>
<style scoped>
@media print {
    .no-print { display: none !important; }
}
</style>
